import { Select, SelectContent, SelectItem, SelectTrigger } from "design-system/molecules/Select"
import { cn } from "design-system/utils"
import { useUpdateCampaignTemplateStatusMutation } from "modules/campaigns/hooks/useUpdateCampaignTemplateStatusMutation"
import { Loading } from "modules/shared/components/Loading"
import { useTranslation } from "react-i18next"

const UPDATE_STATUS_MAP: Record<"active" | "inactive", string[]> = {
  active: ["inactive"],
  inactive: ["active"],
}

type Props = {
  campaignId: string
  templateId: string
  status: "active" | "inactive"
  disabled?: boolean
}

export const CampaignTemplateStatus = ({ campaignId, templateId, status, disabled }: Props) => {
  const { t } = useTranslation()

  const { mutate, isPending } = useUpdateCampaignTemplateStatusMutation({
    campaignId,
    templateId,
  })

  if (isPending) return <Loading />

  return (
    <Select
      value={status}
      disabled={disabled}
      onValueChange={(value) => {
        mutate(value as "active" | "inactive")
      }}
    >
      <SelectTrigger
        onClick={(e) => e.stopPropagation()}
        className="text-base pl-3.5 pr-2 w-32 hover:cursor-pointer hover:border-muted-foreground hover:bg-muted/50"
      >
        <div className="flex items-center gap-1.5 whitespace-nowrap">
          <span className="relative flex size-3 shrink-0 items-center justify-center">
            {status === "active" && (
              <span className="absolute size-2 animate-ping rounded-full bg-success" />
            )}
            <span
              className={cn(
                "relative size-2 rounded-full",
                status === "active" ? "bg-success" : "bg-muted-foreground",
              )}
            />
          </span>
          {t(`campaigns.templates.whatsapp.actions.${status}`)}
        </div>
      </SelectTrigger>
      <SelectContent>
        {UPDATE_STATUS_MAP[status].map((nextStatus) => (
          <SelectItem key={nextStatus} value={nextStatus}>
            {t(`campaigns.templates.whatsapp.actions.${nextStatus}`)}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}
